(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Text = include('createjs.Text'),
		Bitmap = include('createjs.Bitmap'),
		Delay = include('springroll.DelayedCall'),
		Container = include('createjs.Container');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class CountMeToSheep.GamePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var GamePanel = function()
	{
		BasePanel.call(this);

		this.launchReady = this.launchReady.bind(this);
		this.loadLauncher = this.loadLauncher.bind(this);
		this.launchSheep = this.launchSheep.bind(this);
		this.launchComplete = this.launchComplete.bind(this);
		this.startGame = this.startGame.bind(this);
	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(GamePanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		// spritesheet generation
		// setup
		

		// counting


		//Count encourages player to keep going
		this.countAnimations = {
			"keepCounting": [
				{
					anim: "keepcounting1",
					audio: "Countsheep_59"
				},
				{
					anim: "keepcounting2",
					audio: "Countsheep_62"
				},
				{
					anim: "keepcounting3",
					audio: "Countsheep_63"
				},
				{
					anim: "keepcounting4",
					audio: "Countsheep_66"
				},
				{
					anim: "keepcounting5",
					audio: "Countsheep_67"
				},
				{
					anim: "keepcounting6",
					audio: "Countsheep_47"
				},
				{
					anim: "keepcounting7",
					audio: "Countsheep_48"
				},
				{
					anim: "keepcounting8",
					audio: "Countsheep_53"
				},
				{
					anim: "keepcounting9",
					audio: "Countsheep_58"
				}
			],
			//Intro sequence
			"intro": [
				{
					anim: "intro1",
					audio: "Countsheep_1"
				},
				{
					anim: "intro3",
					audio: "Countsheep_2_fix"
				},
				function() {
					app.sound.play("thunder");
				},
				{
					anim: "intro4",
					audio: "Countsheep_4_ALT2"
				},
				{
					anim: "intro5",
					audio: "Countsheep_3_ALT"
				},
				{
					anim: "intro6",
					audio: "Countsheep_5"
				},
				{
					anim: "intro7",
					audio: "Countsheep_6"
				},
				{
					anim: "intro8",
					audio: "Countsheep_7"
				},
				{
					anim: "intro9",
					audio: "Countsheep_8"
				},
				{
					anim: "intro10",
					audio: "Countsheep_9_ALT"
				},
				{
					anim: "intro11",
					audio: "Countsheep_10_ALT"
				},
				{
					anim: "intro12",
					audio: "Countsheep_11alt"
				}
			],
			"desktop1": ["Countsheep_18"],
			"desktop2": ["Countsheep_23", "Countsheep_24"],
			"mobile1": ["Countsheep_14", "Countsheep_15", "Countsheep_16", "Countsheep_17"], 
			"mobile2": ["Countsheep_25", "Countsheep_26"],
			//Different endings
			"ending1": [
				{
					anim: "ending1",
					audio: "Countsheep_121_ALT3"
				},
				{
					anim: "ending1_thunder",
					audio: "ruckus"
				},
				{
					anim: "ending1_wake",
					audio: "Countsheep_126"
				},
				{
					anim: "ending1_response",
					audio: "Countsheep_127"
				},
				{
					anim: "ending1_countagain",
					audio: "Countsheep_129_ALT"
				},
				{
					anim: "ending1_thunderlaugh",
					audio: "thunderlaugh"
				}
			],
			"ending2": [
				{
					anim: "ending2",
					audio: "Countsheep_121_ALT3"
				},
				{
					anim: "ending2_thunder",
					audio: "ruckus"
				},
				{
					anim: "ending2_wake",
					audio: "Countsheep_130"
				},
				{
					anim: "ending2_response",
					audio: "Countsheep_131"
				},
				{
					anim: "ending2_countagain",
					audio: "Countsheep_133_ALT"
				}
			],
			"ending3": [
				{
					anim: "ending3",
					audio: "Countsheep_121_ALT3"
				},
				{
					anim: "ending3_thunder",
					audio: "ruckus"
				},
				{
					anim: "ending3_wake",
					audio: "Countsheep_134_ALT"
				},
				{
					anim: "ending3_response",
					audio: "Countsheep_137"
				}
			]
		};

		this.state = app.states.game;

		this.skin = new lib.Game();
		this.skin._updateTimeline();

		//Painting+numbers setup
		this.painting = this.skin.painting;
		this.painting.framerate = 24;
		this.painting.gotoAndStop("normalFrom10_stop");
		this.currentCount = 0;
		this.currentGoal = Math.floor(Math.random() * 5) + 1;

		//Sheep launch area setup
		this.launchButton = this.skin.launchButton;
		this.launchButton._updateTimeline();
		this.launchButton.hitArea = this.launchButton.children[0];
		this.launchButton.children[0].visible = false;
		this.waiting = false;
		this.state.launchReady = false;

		this.addChild(this.skin);

		

		//Skip button setup
		this.skipArea = this.skin.skipButton;
		this.skipArea._updateTimeline();
		this.skipArea.hitArea = this.skipArea.children[0];
		this.skipArea.children[0].visible = false;

		this.skipButton = new lib_CountSetup.SkipButton();
		this.skipButton.scaleX = this.skipButton.scaleY = 2;
		this.skipButton.x = this.skipArea.x - 50;
		this.skipButton.y = this.skipArea.y - 50;
		this.skipButton.visible = true;
		this.skin.addChild(this.skipButton);

		//The Count Setup
		this.countSetupSymbol = new lib_CountSetup.Count_Setup();
		this.countSetupSymbol.scaleX = this.countSetupSymbol.scaleY = 2;
		this.countSetupSymbol.x = 75;
		this.countSetupSymbol.y = 25;
		this.countSetupSymbol.gotoAndStop(1);
		this.skin.addChild(this.countSetupSymbol);

		// Ending symbol, since this is too large to instantiate all at once
		this.countEndingsSymbol = new lib_CountEndings.Count_Endings();
		this.countEndingsSymbol.scaleX = this.countEndingsSymbol.scaleY = 2;
 		this.countEndingsSymbol.y = 25;
 		this.countEndingsSymbol.x = 75;
 		this.skin.addChild(this.countEndingsSymbol);
 		this.countEndingsSymbol.visible = false;
 		this.countEndingsSymbol.stop();

		this.activeCountName = null;
		this.countSymbol = null; // placeholder

		this.sheepNum = 0;
		this.sheepStill = null;

		// this.loadScreen = new lib.Transition();
		// this.loadScreen.gotoAndStop(100);
		// this.skin.addChild(this.loadScreen);
	};
	
	p.initializeCount = function(count) {
		if (count === this.activeCountName) {
			// already using the correct symbol. Move along.
			return;
		}

		if (this.countSymbol !== null) {
			// clear any existing count symbols
			this.skin.removeChild(this.countSymbol);
			this.countSymbol = null;
		}
		
		if (count === "main") {
			this.countSymbol = new lib_CountCounting.Count_Counting();
		} else if (count === "timeout") {
			this.countSymbol = new lib_CountTimeouts.Count_Timeouts();
		} else if (count === "keep") {
			this.countSymbol = new lib_CountKeepCounting.Count_KeepCounting();
		} else if (count === "success") {
			this.countSymbol = new lib_CountSuccess.Count_Success();
		} else if (count === "end") {
			this.countSymbol = new lib_CountCountingEnd.Count_CountingEnd();
		} else if (count === "quick") {
			this.countSymbol = new lib_CountCountingQuick.Count_CountingQuick();
		} else {
			// set to null
			this.countSymbol = null;
			return;
		}
		this.countSymbol.scaleX = this.countSymbol.scaleY = 2;
		this.countSymbol.x = 75;
		this.skin.addChildAt(this.countSymbol, this.skin.children.length - 2);
	};

	//Sets up symbols for beginning of game (runs only after intro)
	p.startGame = function() {
		// clear cursors
		this.skipArea.cursor = "CursorDefault";
		this.skipButton.visible = false;
		this.skipArea.visible = false;

		// create gameplay character elements
		// only need to initialize telly and sheep once
		// Telly setup
		this.tellySymbol = new lib_CountTelly.Count_Telly();
		this.tellySymbol.scaleX = this.tellySymbol.scaleY = 2;
		this.tellySymbol.x = 75;
		this.tellySymbol.y = 25;

		this.skin.addChild(this.tellySymbol);

		// Sheep container setup
		this.sheepSymbol = new lib_CountSheep.Count_Sheep();
		this.sheepSymbol.scaleX = this.sheepSymbol.scaleY = 2;
		this.sheepSymbol.x = 75;
		this.sheepSymbol.y = 25;

		this.skin.addChild(this.sheepSymbol);

		//Sheep snapshots area setup
		this.thumbs = new lib.Thumbnails();
		this.thumbs.x = 550;
		this.thumbs.y = 650;
		this.skin.addChild(this.thumbs);

		this.flash = new lib_Flash.CameraFlash();
		this.flash.scaleX = this.flash.scaleY = 2;
		this.flash.x = 75;
		this.flash.y = 25;
		this.flash.framerate = 24;
		this.skin.addChild(this.flash);
		this.flash.stop();

		// use count swapping system
		this.initializeCount("main");

		// clean up previous scene elements

		this.skin.removeChild(this.countSetupSymbol);
		this.countSetupSymbol = null;

		app.animator.stopAll();
		app.voPlayer.play("");
		createjs.Tween.removeAllTweens();

		this.addSheepStill();

		app.animator.play(this.tellySymbol, "tellyidle");
		app.animator.play(this.countSymbol, ["idleToCount", "idle"]);
		app.animator.play(this.sheepSymbol, "launchPrep", this.launchReady());

		this.roundStart = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000);
		GTM_obj.trackGTMEvent('gameRoundStart', {'roundNumber' : app.config.globalState.currentRound});
	};

	//Prepares the sheep for launch
	p.launchReady = function() {
		this.state.launchReady = true;
		this.state.startTimeout();
		this.waiting = true;
	};

	//Moves the spring down + causes Telly to look at the sheep
	p.loadLauncher = function() {
		if (this.state.launchReady === false) {
			// always finish a launch that is already playing
			return;
		}
		app.animator.play(this.sheepSymbol, [{anim:"loadSheep", audio: "spring_down"}, {anim: "loadedSheepIdle"}]);
		app.animator.play(this.tellySymbol, ["watchSheep", "watchSheepLoadIdle"]);
		this.launchButton.cursor = "CursorDefault";
	};

	p.addSheepStill = function() {
		if (this.sheepStill !== null) {
			this.sheepSymbol.sheepPose.removeAllChildren();
			this.sheepStill = null;
		}

		//Chooses a random sheep to launch
		this.sheepNum = app.leftpad(Math.floor(Math.random() * 100) + 1, 4, 0);
		var sheepName = "sheep_" + this.sheepNum;
		this.sheepStill = new lib_CountSheepStills[sheepName]();

		this.sheepStill.scaleX = this.sheepStill.scaleY = 0.4;
		sheepStillSize = {x: 525, y: 495};
		this.sheepStill.x = (sheepStillSize.x / 2) * this.sheepStill.scaleX * -1;
		this.sheepStill.y = (sheepStillSize.y / 2) * this.sheepStill.scaleY * -1;
		
		this.sheepSymbol.sheepPose.addChild(this.sheepStill);
	};

	//Launches sheep
	p.launchSheep = function() {
		if (this.state.launchReady === false) {
			// always finish a launch that is already playing
			return;
		}
		this.state.launchReady = false;
		this.waiting = false;

		//Finds the corresponding snapshot for the sheep and adds it to the screen
		var sheepThumb = new createjs.Sprite(ss.Count_SheepThumbs_atlas_);
 		sheepThumb.gotoAndStop(this.sheepNum - 1);
		sheepThumb.scaleX = 0;
		sheepThumb.scaleY = 0;

		this.thumbs.children[this.currentCount].addChild(sheepThumb);
		createjs.Tween.get(sheepThumb)
			.call(function() {
				app.voPlayer.play("thumb_appear");
			}.bind(this))
			.to({scaleX: 1, 
				scaleY: 1}, 1500, createjs.Ease.backOut)
			.call(function() {
				app.voPlayer.play("thumb_settles");
			}.bind(this));

		//Keeps track of sheep count
		this.currentCount++;
		app.animator.play(this.painting, "num" + this.currentCount);

		this.flash.visible = true;
		createjs.Tween.get(this.flash)
			.wait(400)
			.call(function() {
				app.animator.play(this.flash, {anim: "launch", audio: "camerafx"});
			}.bind(this));

		app.animator.play(this.sheepSymbol, [{anim: "launch", audio: "spring_up"}, 
			{anim: "finishLaunch"}, {anim: "flip", audio: "flips"}, {anim: "land", audio: "lands"}, 
			{anim: "sheepExit"}], 
			this.launchComplete.bind(this));

		app.animator.play(this.tellySymbol, ["watchSheepLaunch", "tellyidle"]);

		var callback = function() {
			this.flash.visible = false;
			this.playPayoff();
		}.bind(this);

		this.state.stopTimeout();
		this.initializeCount("main");
		app.animator.play(this.countSymbol, [
			{
				anim: "count" + this.currentCount,
				audio: "Countsheep_" + (this.currentCount + 77)
			}
		], callback);
	};

	//Randomly decides to encourage the player or not
	p.playPayoff = function() {
		var callback = function() {
			this.initializeCount("main");
			app.animator.play(this.countSymbol, "idle");
		}.bind(this);

		var encourage = Math.floor(Math.random() * 6);
		var index = Math.floor(Math.random() * this.countAnimations.keepCounting.length);
		if (encourage >= 2) {
			this.initializeCount("keep");
			app.animator.play(this.countSymbol, this.countAnimations.keepCounting[index], callback);
		} else {
			app.animator.play(this.countSymbol, "idle");
		}
	};

	//Checks sheep count after each launch
	p.launchComplete = function() {
		if (this.currentCount < this.currentGoal) {
			// prep for the next launch
			app.animator.play(this.sheepSymbol, [{anim:"launchPrep", audio: "jump_in"}, 
				{anim: "ba", audio: "Countsheep_39_ALT2"}], this.launchReady.bind(this));

			this.addSheepStill();
			console.log(this.currentGoal);
		} else {
			// begin final animation
			var countThumbs = function() {
				this.countThumbs();
			}.bind(this);

			var callback = function() {
				app.animator.play(this.tellySymbol, {anim: "tellysnore", audio: "Countsheep_snorefix"});
				this.initializeCount("success");
				var anim = Math.floor(Math.random() * 2) + 1;
				var aud = 111 - anim;
				app.animator.play(this.countSymbol, [
					{
						anim: "success" + anim,
						audio: "Countsheep_" + aud
					},
					{
						anim: "success" + anim + "b",
						audio: "Countsheep_111B"
					}
				], countThumbs);
			}.bind(this);

			app.animator.play(this.tellySymbol, "tellysleep", callback);
		}
	};

	//Counts the sheep snapshots after the player reaches the target amount
	p.countThumbs = function() {
		this.initializeCount("quick");

		var countList = [];

		for (var i = 1; i <= this.currentCount; i++) {
			countList.push(this.enlargeThumbnail(i - 1));
			countList.push({anim: "quickcount" + i, audio: "Countsheep_" + (i+87)});
		}

		var callback = function() {
			this.switchCount();
		}.bind(this);

		app.animator.play(this.countSymbol, countList, callback);

		// for (var k = 0; k < this.currentGoal; k++) {
		// 	this.animateThumbnails(this.thumbs.children[k], k);
		// }
	};

	//Count announces total amount and snapshots disappear 
	p.switchCount = function() {
		this.initializeCount("end");
		var callback = function() {
			for (var i = 0; i < this.currentGoal; i++) {
				this.shrinkThumbnail(i);
			}
			app.voPlayer.play("thumb_fall");
			app.animator.play(this.painting, "normalFrom" + this.currentGoal, this.wakeTelly());
		}.bind(this);

		app.animator.play(this.painting, {anim:"highlighted" + this.currentGoal, audio:"total"});
		app.animator.play(this.countSymbol, {anim: "count" + this.currentGoal + "End", 
			audio: "Countsheep_" + (this.currentGoal + 110)}, callback);
	};

	//Random end sequence plays and wakes Telly up again
	p.wakeTelly = function() {
		var callback = function() {
			this.resetStage();
		}.bind(this);

		var ending = Math.floor(Math.random() * 3) + 1;

		this.countEndingsSymbol.visible = true;
		
		this.initializeCount("none");
		this.sheepSymbol.visible = false;
		this.tellySymbol.visible = false;
		app.animator.stopAll();
		this.sheepSymbol.stop();
		this.tellySymbol.stop();

		app.animator.play(this.countEndingsSymbol, this.countAnimations["ending" + ending], callback);
	};

	//Resets the stage after each round
	p.resetStage = function() {
		var duration = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000) - this.roundStart;
		var timeInSeconds = Math.round((Date.now() - app.config.globalState.timeOfGameStart) / 1000);
		GTM_obj.trackGTMEvent('gameRoundComplete', {'roundNumber' : app.config.globalState.currentRound, 
			'duration' : duration});
		app.config.globalState.gamePlayDone = true;
		if (app.config.globalState.currentRound == 1) {
			GTM_obj.trackGTMEvent('gamePlaythroughComplete', {'duration' : timeInSeconds});
		}

		createjs.Tween.removeAllTweens();
		this.initializeCount("main");
		this.sheepSymbol.visible = true;
		this.tellySymbol.visible = true;

		this.countEndingsSymbol.visible = false;
		
		app.animator.play(this.tellySymbol, "tellyidle");
		app.animator.play(this.countSymbol, ["idleToCount", "idle"]);
		for (var i = 0; i < this.currentGoal; i++) {
			this.thumbs.children[i].removeAllChildren();
			this.thumbs.children[i].x = -340 + (100*i);
			this.thumbs.children[i].y = 0.1;
			this.thumbs.children[i].scaleX = 1;
			this.thumbs.children[i].scaleY = 1;
			this.thumbs.children[i].rotation = 0;
		}
		this.currentCount = 0;
		this.currentGoal = Math.floor(Math.random() * 5) + 1;
		app.config.globalState.currentRound++;
		this.launchComplete();	

		this.roundStart = Math.round((Date.now() - app.config.globalState.timeOfGameStart)/ 1000);
		GTM_obj.trackGTMEvent('gameRoundStart', {'roundNumber' : app.config.globalState.currentRound});
	};

	//Controls the sheep snapshot animations
	p.shrinkThumbnail = function(picNumber) {
		var pic = this.thumbs.children[picNumber];
		createjs.Tween.get(pic)
			.to({scaleX: 0, scaleY: 0}, 3000);
		createjs.Tween.get(pic)
			.to({x: pic.x - 40, y: pic.y + 200}, 3000);
		createjs.Tween.get(pic, {loop: true})
			.to({rotation: 360}, 500);
	};

	p.enlargeThumbnail = function(picNumber) {
		var pic = this.thumbs.children[picNumber];
		return function() {
			createjs.Tween.get(pic)
				.to({scaleX: 1.25, scaleY: 1.25}, 200)
				.call(function() {
					app.sound.play((picNumber + 1) + "ding");
				}.bind(this));
		}.bind(this);
	};

	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		s.teardown.call(this);
		this.skin = null;
	};

	//Assign to namespace
	namespace('CountMeToSheep').GamePanel = GamePanel;
})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{});
var lib, images, createjs, ss;